<template>
  <div class="color-tags">
    <span
      v-for="(item, index) in tags"
      :key="index"
      class="color-tags__item">
      {{ item }}
    </span>
  </div>
</template>

<script>
export default {
  name: "color-tags",
  props: ["tags"]
}
</script>

<style lang="scss">
.color-tags {
  display: flex;
  flex-wrap: wrap;
  &__item {
    background: #FF9696;
    border-radius: 3px;
    color: #ffffff;
    padding: 6px 13px;
    margin-right: 8px;
    margin-bottom: 8px;
    &:nth-of-type(2n) {
      background: #00CA69;
    }
    &:nth-of-type(3n) {
      background: #969AFF;
    }
    &:nth-of-type(4n) {
      background: #FFB341;
    }
    &:nth-of-type(5n) {
      background: #388DCA;
    }
  }
}
</style>